import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseTmaisRafflesProps<T> = {
  filters?: {
    search?: string
    page?: number
    status?: string
    creatorEstablishmentCompanyBranchId?: string
    availableFromGteq?: string
    availableFromLteq?: string
  }
  mapper?: (data: any) => T,
}

export const useTmaisRaffles = <T,>({
  filters: {
    search = '',
    page,
    status,
    creatorEstablishmentCompanyBranchId,
    availableFromGteq,
    availableFromLteq,
  } = {},
  mapper = Mapper.default<T>(),
}: UseTmaisRafflesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: [
      'tmaisRaffles',
      search,
      page,
      status,
      creatorEstablishmentCompanyBranchId,
      availableFromGteq,
      availableFromLteq,
    ],
    queryFn: () => {
      return privateAxios.get(`/tmais/raffles`, {
        params: {
          search,
          page,
          'q[status_eq]': status,
          'q[creator_establishment_company_branch_id_eq]':
            creatorEstablishmentCompanyBranchId !== 'null' ? creatorEstablishmentCompanyBranchId : undefined,
          'q[creator_establishment_company_branch_id_null]':
            creatorEstablishmentCompanyBranchId === 'null' ? true : undefined,
          'q[available_from_gteq]': availableFromGteq,
          'q[available_from_lteq]': availableFromLteq,
        },
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
